import { reactive, toRefs } from "vue";
const initialState = {};
export function useConfig() {
    const state = reactive(initialState);
    const setConfig = (config) => {
        state.apiUrl = config.apiUrl;
        state.arxivLink = config.arxivLink;
        state.linkText = config.linkText;
        state.linkTitle = config.linkTitle;
    };
    return {
        ...toRefs(state),
        setConfig
    };
}
